var map = {
	"./campaign-active.svg": "fe4f",
	"./campaign.svg": "160d",
	"./catalog-active.svg": "84b3",
	"./catalog.svg": "6a82",
	"./favorites-active.svg": "6a40",
	"./favorites.svg": "3d81",
	"./help-active.svg": "c7bc",
	"./help.svg": "634a",
	"./import-active.svg": "83a0",
	"./import.svg": "d3a9",
	"./mygroups-active.svg": "674b",
	"./mygroups.svg": "0d06",
	"./rate.svg": "f03c",
	"./request-active.svg": "d2ca",
	"./request.svg": "69b3",
	"./settings-active.svg": "f083",
	"./settings.svg": "000e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ff4e";